import React, { useState } from 'react'
import {
  Box,
  Button,
  FormControl,
  Grid,
  Modal,
  TextField,
} from '@material-ui/core'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import swal from 'sweetalert'
import Swal from 'sweetalert2'
import { deleteBlockingMipyme } from '../../../services/IFI/delete'

export const ModalActive = ({ open, setOpen, getForms, IdMiPyme, b2c }) => {
  const [loading, setLoading] = useState(false)
  const [errorDescription, setErrorDescription] = useState(false)

  const GeneralDataSchema = Yup.object().shape({
    Justification: Yup.string()
      .required('Este campo es obligatorio')
      .matches(
        /^[-():;,%#./\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
        'Caracteres especiales no aceptados',
      )
      .max(100, 'Máximo 100 caracteres'),
  })

  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: false,
    initialValues: {
      Justification: '',
      IdMiPyme: IdMiPyme,
      IdUserB2C: b2c,
      LockType: 2,
    },
    validationSchema: GeneralDataSchema,
    onSubmit: (values) => {
      saveForm(values)
    },
  })

  const saveForm = async (values) => {
    setLoading(true)
    try {
      const response = await deleteBlockingMipyme(values)
      if (response.Success) {
        Swal.fire({
          title: '¡Usuario Activado Exitosamente!',
          icon: 'success',
          confirmButtonText: 'Entendido',
          confirmButtonColor: '#3085d6',
        })
        setLoading(false)
        getForms()
        handleClose()
      }
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  }

  const validateFormStatus = () => {
    formik
      .validateForm()
      .then((values) => {
        if (Object.entries(values).length === 0) {
          formik.submitForm()
        } else {
          alertValidationFields()
        }
      })
      .catch((error) => console.log('ERROROR', error))
  }

  const alertValidationFields = () => {
    swal({
      title: 'Favor validar: Si hay campos pendientes por completar.',
      icon: 'warning',
      button: 'Entendido',
      className: 'swal-title',
    })
  }

  const handleClose = () => {
    setOpen(false)
    formik.resetForm()
  }

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modalPYME">
          <div className="pymeDiv">
            <h1 className="pymeTitle">Activar MIPYME</h1>
          </div>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  Justificación <span style={{ color: 'red' }}>*</span>
                </label>
              </Grid>
              <FormControl style={{ width: '100%' }}>
                <textarea
                  style={{
                    border: '1px solid #000000',
                    height: '80px',
                    resize: 'none',
                  }}
                  id="ClimateThreat"
                  customInput={TextField}
                  value={formik.values.Justification}
                  onChange={(e) => {
                    if (
                      e.target.value.match(
                        /[-():;,%#./\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
                      ) ||
                      e.target.value === ''
                    ) {
                      setErrorDescription(false)
                      formik.setFieldValue(
                        'Justification',
                        e.target.value.trimStart(),
                      )
                    } else {
                      setErrorDescription(true)
                    }
                  }}
                  maxLength={100}
                ></textarea>
                {formik.errors.Justification ? (
                  <div
                    style={{
                      color: 'red',
                      marginTop: '3px',
                      fontSize: '13px',
                    }}
                  >
                    {formik.errors.Justification}
                  </div>
                ) : null}
                {errorDescription ? (
                  <div
                    style={{
                      color: 'red',
                      marginTop: '3px',
                      fontSize: '13px',
                    }}
                  >
                    Caracteres especiales no aceptados
                  </div>
                ) : null}
              </FormControl>
            </Grid>

            <Grid container spacing={1} className="input__container">
              <Grid className="buttonsPYME" style={{ marginTop: '3%' }}>
                <Button className="cancelButton" onClick={handleClose}>
                  Cancelar
                </Button>
                <Button
                  className="confirmButton"
                  type="button"
                  onClick={validateFormStatus}
                  disabled={loading}
                >
                  Guardar
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </>
  )
}
